import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import VdpVideo from '../Components/Vdp/VdpVideo'
import { getImages } from '../Common/const'
import { VehicleContext } from '../Context/VehicleContext'
import UseScrollReveal from '../Common/UseScrollReveal';
import Fancybox from '../Common/Fancybox';
import { Field, Form, Formik, ErrorMessage } from 'formik';
import ReCAPTCHA from 'react-google-recaptcha'
import ReadMore from '../Components/Vdp/ReadMore'
import SeoMeta from '../Common/SeoMeta'
const Vdp = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const optionsVdp = {
        responsive: {
            0: {
                items: 2,
                margin: 10
            },
            600: {
                items: 2,
                margin: 20
            },
            768: {
                items: 3,
                margin: 25
            },
            1000: {
                items: 3,
                margin: 25
            }
        },
    };

    const [vehicleVIN, setVehicleVIN] = useState("");

    const { vehiclesByVIN, vehicleVINsbyID, numberFormatter, priceFormatter, submitContactForm, getVehicleData } = useContext(VehicleContext);
    const recaptchaRef = React.useRef();

    useEffect(() => {
        getVehicleData();
    }, []);
    const [vehicleData, setVehicleData] = useState({});

    const [vehicleExist, setVehicleExist] = useState(false);

    useEffect(() => {
        if (location && !vehicleVIN && vehiclesByVIN) {
            let vin = location.pathname.slice(location.pathname.lastIndexOf("-") + 1, location.pathname.length);
            if (vin in vehiclesByVIN) setVehicleVIN(vin);
            else if(vin in vehicleVINsbyID) {
                console.log("found vehicle ID",vin,vehicleVINsbyID[vin],vehicleVINsbyID);
                setVehicleVIN(vehicleVINsbyID[vin]);
            } else navigate("/cars-for-sale-florida-california");

            console.log("vin test", vin);
        }
    }, [location, vehiclesByVIN]);

    useEffect(() => {
        if (vehicleVIN && vehiclesByVIN && vehicleVIN in vehiclesByVIN) {
            var vehicle_data = vehiclesByVIN[vehicleVIN];
            // Get all images except the first one
            vehicle_data.gallery_images = vehicle_data.images.slice(1);
            setVehicleData(vehicle_data);
            setVehicleExist(true);
        }
    }, [vehicleVIN, vehiclesByVIN]);

    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        // Function to scroll to the section
        const scrollToSection = () => {
            const hash = location.hash;
            if (hash) {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        };

        // Scroll after a slight delay to ensure DOM updates are complete
        const timeoutId = setTimeout(scrollToSection, 2000);

        // Clean up the timeout if the component unmounts
        return () => clearTimeout(timeoutId);
    }, [vehicleData]);

    // Is Loaded
    const [isDataLoaded, setIsDataLoaded] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setIsDataLoaded(false);
        }, 2000);
    }, [vehicleData]);

    // If Vin not Found navigate page 
    useEffect(() => {
        if (!vehicleVIN || !vehiclesByVIN) {
            return;
        }

        // Case-insensitive match
        const match = Object.values(vehiclesByVIN).find(
            (v) => v.vin.toLowerCase() === vehicleVIN.toLowerCase()
        );

        if (!match) {
            navigate("/cars-for-sale-florida-california");
        }
    }, [vehicleVIN, vehiclesByVIN, navigate]);

    // End If Vin not Found navigate page 

    const [tooltipVisible, setTooltipVisible] = useState(false);
    const handleCopy = () => {
        const textArea = document.createElement('textarea');
        textArea.value = vehicleData.vin;
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            showTooltip();
        } catch (err) {
            console.error('Failed to copy text:', err);
        }
        document.body.removeChild(textArea);
    };

    const showTooltip = () => {
        setTooltipVisible(true);
        setTimeout(() => {
            setTooltipVisible(false);
        }, 2000);
    };


    const scrollToInquire = () => {
        const section = document.getElementById('gotAQuestion');
        section.scrollIntoView({ behavior: 'smooth' });
    };

    const sectionRef = useRef(null);
    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };
    // Mobile view condition
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [showAll, setShowAll] = useState(false);
    const visibleItems = showAll ? vehicleData?.descriptions : vehicleData?.descriptions?.slice(0, 6);
    const galleryRef = useRef(null);
    const openGallery = () => {
        const flatImages = vehicleData?.gallery_images?.flat();
        const items = flatImages.map((src) => ({ src, type: "image" }));

        // NativeFancybox.show(items);
    };

    var srpCarSlider = {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: false,
    };
    UseScrollReveal();
    const galleryWrapRef = useRef(null);
    const [isGalleryNearTop, setIsGalleryNearTop] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (galleryWrapRef.current) {
                const rect = galleryWrapRef.current.getBoundingClientRect();
                if (rect.top <= 100) {
                    setIsGalleryNearTop(true);
                    document.body.classList.add('add-sticky-sec');
                } else {
                    setIsGalleryNearTop(false);
                    document.body.classList.remove('add-sticky-sec');
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    
    const seoTitle = vehicleExist ? `${vehicleData.year} ${vehicleData.make} ${vehicleData.model} ${priceFormatter(vehicleData.price, true)} |` : "";
    return (
        <>
            <SeoMeta
                title={`${seoTitle} Pre-Owned Vehicle Dealership Tampa, FL and San Clemente, CA`}
                description={vehicleExist && `For Sale ${vehicleData.year} ${vehicleData.make} ${vehicleData.model} at ${priceFormatter(vehicleData.price, true)} available at European Exotic Center CA- your pre-owned vehicle dealership located near Tampa, FL and San Clemente, CA. We're here to help with any automotive needs you may have.`}
                keywords=''
                ogTitle={`${seoTitle} Pre-Owned Vehicle Dealership Tampa, FL and San Clemente, CA`}
                ogDescription={vehicleExist && `For Sale ${vehicleData.year} ${vehicleData.make} ${vehicleData.model} at ${priceFormatter(vehicleData.price, true)} available at European Exotic Center CA- your pre-owned vehicle dealership located near Tampa, FL and San Clemente, CA. We're here to help with any automotive needs you may have.`}
            />
            {vehicleExist ?
                <>
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6LckXRIsAAAAAAiOe2UBkXy7Uy-ROdiueqrr4Lzk" // Replace with your actual site key
                        size="invisible"
                    />
                    <section className='vdp-new-banner-wrap' style={{ background: `#000 url(${getImages('vdp-banner-bg.png')}) no-repeat center center / cover` }}>
                        {/* <img className='w-100' src={getImages('vdp-new-bg.jpg')} alt='vdp' /> */}
                        <div className='container'>
                            <div className='custom-breadcrumb mb-4 mt-3'>
                                <nav style={{ "--bs-breadcrumb-divider": "'>'" }} aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/cars-for-sale-florida-california">Models</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">{vehicleData.make}</li>
                                    </ol>
                                </nav>
                            </div>
                            <div className='d-md-flex justify-content-between vdpb-flex-wrap'>
                                <div className='vdp-image order-md-2  wow reveal fadeIn'>
                                    {/* <img src={getImages('car-isolated.png')}/> */}
                                    {vehicleData.vdp_hero_image ?
                                        <img src={vehicleData.vdp_hero_image} alt='hero'
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = getImages(`vdp_top_coming_soon.png`);
                                            }}
                                        />
                                        :
                                        <img src={getImages('vdp_top_coming_soon.png')} alt='hero' />
                                    }
                                    {vehicleData?.inventory_manage?.pending && 
                                        <div className='vdp-pending-tag'>
                                            <img src={getImages('sale-pending-vdp.png')} alt='sale pending'/>
                                        </div>
                                    }
                                </div>
                                <div>
                                    <div className='vdpb-left-box mt-70 wow reveal fadeInLeft'>
                                        <div className='vdp-title1'>{vehicleData.year}</div>
                                        <div className='vdp-title2 my-2'>{vehicleData.make}</div>
                                        <div className='vdp-title3'>{vehicleData.model} {vehicleData.trim}</div>
                                        <div className='vdp-title4 mt-3'>{priceFormatter(vehicleData.mileage)} miles</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`vdpn-bottom ${isGalleryNearTop ? 'fixed' : ''}`}>
                            <div className='container'>
                                <div className='d-md-flex align-items-center justify-content-between vdpn-b-flex'>
                                    <div className='d-md-block d-none'>
                                        {vehicleData.location === "San Clemente, CA" ? 
                                            <a href="tel:9492731100" className='d-md-flex d-none align-items-center wow reveal fadeInLeft'>
                                                <div className='me-lg-4 me-3'><img src={getImages('arrow.svg')} /></div>
                                                <div className='lg-title fw-300 text-uppercase font-1-5em'>(949) 273-1100</div>
                                            </a> :
                                            <a href="tel:8135927722" className='d-md-flex d-none align-items-center wow reveal fadeInLeft'>
                                                <div className='me-lg-4 me-3'><img src={getImages('arrow.svg')} /></div>
                                                <div className='lg-title fw-300 text-uppercase font-1-5em'>(813) 592-7722</div>
                                            </a>
                                        }
                                    </div>
                                    <div className='d-flex align-items-center vdpn-b-right wow reveal fadeInRight'>
                                        <div className='me-lg-5 me-3 d-md-flex align-items-center'>
                                            <div className='xs-title avenir-next opacity-0-5 me-4'>Price</div>
                                            <div className={(isMobile && vehicleData.price == 0 ? 'xs-title' : 'lg-title' ) + ' avenir-next text-uppercase fw-700 letter-spacing-0'}>{priceFormatter(vehicleData.price, true)}</div>
                                        </div>
                                        <div>
                                            <button type='button' onClick={scrollToSection} className='orange-white-btn text-uppercase fw-bold d-inline-block w-240 lg-btn'>Request Info</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className='vdp-new-gallery-wrap' ref={galleryWrapRef}>
                        <div className='container'>
                            <div className='d-md-none text-center mb-3'>
                                {vehicleData.location === "San Clemente, CA" ? 
                                    <a href="tel:9492731100" className='d-inline-flex align-items-center wow reveal fadeInLeft'>
                                        <div className='me-3'><img className='vd-arrow-icon' src={getImages('mob-phone-icon.png')} /></div>
                                        <div className='lg-title fw-300 text-uppercase font-19'>(949) 273-1100</div>
                                    </a> :
                                    <a href="tel:8135927722" className='d-inline-flex align-items-center wow reveal fadeInLeft'>
                                        <div className='me-3'><img className='vd-arrow-icon' src={getImages('mob-phone-icon.png')} /></div>
                                        <div className='lg-title fw-300 text-uppercase font-19'>(813) 592-7722</div>
                                    </a>
                                }
                            </div>
                            <Fancybox
                                options={{
                                    Carousel: {
                                        infinite: false,
                                        preload: 1
                                    },
                                }}
                            >
                                <div className='row g-lg-5 g-3'>
                                    {vehicleData.gallery_images &&
                                        vehicleData.gallery_images.map((img, i) => (
                                            <div
                                                key={i}
                                                className={`col-6 wow reveal fadeInUp ${i >= 6 ? "d-none" : ""}`} // hide after 6th
                                            >
                                                <div className="vdpn-gallery-box">
                                                    <a
                                                        data-fancybox="gallery_1"
                                                        ref={i === 0 ? galleryRef : null}
                                                        href={img}
                                                        className="position-relative"
                                                    >
                                                        <img src={img} alt={`gallery-${i}`} loading="lazy" />
                                                    </a>

                                                    {/* Overlay +X only on the 6th image */}
                                                    {i === 5 && (
                                                        <div className="vdpn-more-count lg-title font-2em"
                                                            onClick={() => galleryRef.current?.click()}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            +{vehicleData.gallery_images.length - 6}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}

                                </div>
                            </Fancybox>
                        </div>
                    </section>
                    <section className='vdp-content-wrap'>
                        <div className='container'>
                            <div className='vdpa-block row'>
                                <div className='col-lg-4 order-lg-2 mb-3 mb-lg-0'>
                                    <div className='vdpa-box h-100'>
                                        <div className='md-title text-uppercase mb-3 fw-700 wow reveal fadeInUp'>Vehicle Info</div>
                                        <div className='vdpa-table'>
                                            <table className='w-100'>
                                                <tbody>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Stock</th>
                                                        <td>{vehicleData.stockno}</td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>VIN</th>
                                                        <td className="text-nowrap">
                                                            <span className='position-relative copy-info'>
                                                                <span className='copy_icon' onClick={handleCopy} style={{ cursor: 'pointer' }}></span>
                                                                {tooltipVisible && <span className='copy-tooltip'>Copied!</span>}
                                                            </span>
                                                            {vehicleData.vin}
                                                        </td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Year</th>
                                                        <td>{vehicleData.year}</td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Make</th>
                                                        <td>{vehicleData.make}</td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Model</th>
                                                        <td>{vehicleData.model}</td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Trim</th>
                                                        <td>{vehicleData.trim}</td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Mileage</th>
                                                        <td>{priceFormatter(vehicleData.mileage)}</td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Body Style</th>
                                                        <td>{vehicleData.body_style}</td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Exterior Color</th>
                                                        <td>{vehicleData.exterior_color}</td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Interior Color</th>
                                                        <td>{vehicleData.interior_color}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className='mt-md-4 mt-3 mb-2 wow reveal fadeInUp'>
                                            <div className='text-center carfax-tag'>
                                                <a href={'http://www.carfax.com/VehicleHistory/p/Report.cfx?partner=DVW_1&vin=' + vehicleData.vin} target="_blank">
                                                    <img src={getImages('carfax-tag.png')} alt='carfax' />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-8' id="aboutVdp">
                                    <div className='vdpa-box vdpa-about-box h-100'>
                                        <div className='d-flex align-items-center wow reveal fadeInUp mb-4'>
                                            <div className='me-lg-4 me-3'><img src={getImages('arrow.svg')} /></div>
                                            <div className='lg-title fw-300 text-uppercase font-1-5em'>{vehicleData.location === "San Clemente, CA" ? "(949) 273-1100" : "(813) 592-7722"}</div>
                                        </div>
                                        <div className='vdp-title2 font-2-5em text-uppercase mb-3 wow reveal fadeInUp'>About this Vehicle</div>
                                        {/* <p className='wow reveal fadeInUp' dangerouslySetInnerHTML={{ __html: vehicleData.description }}></p> */}
                                        {/* <ReadMore html={vehicleData.description} maxChars={500} /> */}
                                        <p className="wow reveal fadeInUp vdp-readmore-content" dangerouslySetInnerHTML={{ __html: vehicleData?.description || "" }}></p>
                                        <div id="gotAQuestion" ref={sectionRef}>
                                            <div className='vdp-title3 font-1-5em fw-700 mt-2 pt-md-5 pt-3 mb-80 wow reveal fadeInUp'>Got a question? <a href="#" className='text-theme'>Call</a> or <a href="#" className='text-theme'>Chat</a> live with a sales representative</div>
                                            <Formik
                                                // validationSchema={validationSchema}
                                                initialValues={{
                                                    full_name: '',
                                                    email: '',
                                                    phone: '',
                                                    comment: '',
                                                    vin: vehicleData.vin,
                                                    year: vehicleData.year,
                                                    make: vehicleData.make,
                                                    model: vehicleData.model,
                                                    trim: vehicleData.trim,
                                                    mileage: vehicleData.mileage,
                                                    exterior: vehicleData.exterior_color,
                                                    location: vehicleData.location
                                                }}
                                                onSubmit={async (values, { resetForm }) => {
                                                    const token = await recaptchaRef.current.executeAsync();
                                                    recaptchaRef.current.reset(); // Reset after use

                                                    values.token = token;

                                                    console.log(values);
                                                    const data = await submitContactForm(values);

                                                    if (data.success) {
                                                        resetForm();
                                                        alert("Thank you for your submission. We'll be in touch soon!");
                                                    } else
                                                        alert("There was a problem with your submission");
                                                }}
                                            >
                                                {({ values, setFieldValue, field, form }) => (
                                                    <Form className="custom-form vdp-contact-form" autoComplete="off" name="contact-form">
                                                        <Field type="hidden" name="vin" value={vehicleData.vin} />
                                                        <Field type="hidden" name="year" value={vehicleData.year} />
                                                        <Field type="hidden" name="make" value={vehicleData.make} />
                                                        <Field type="hidden" name="model" value={vehicleData.model} />
                                                        <Field type="hidden" name="trim" value={vehicleData.trim} />
                                                        <Field type="hidden" name="mileage" value={vehicleData.mileage} />
                                                        <Field type="hidden" name="exterior" value={vehicleData.exterior_color} />
                                                        <Field type="hidden" name="location" value={vehicleData.location} />
                                                        <div className='row gx-5'>
                                                            <div className='col-md-6 wow reveal fadeInUp'>
                                                                <div className='form-group mb-3'>
                                                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                                                        <div className='cs-label mb-0'>Full Name</div>
                                                                        <div className='cs-require'>* Required</div>
                                                                    </div>
                                                                    <Field
                                                                        type="text"
                                                                        name="full_name"
                                                                        className="form-control"
                                                                        required />
                                                                    <ErrorMessage name="full_name" component="div" className="text-danger" />
                                                                </div>
                                                                <div className='form-group mb-3'>
                                                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                                                        <div className='cs-label mb-0'>Email</div>
                                                                        <div className='cs-require'>* Required</div>
                                                                    </div>
                                                                    <Field
                                                                        type="text"
                                                                        name="email"
                                                                        className="form-control"
                                                                        required />
                                                                    <ErrorMessage name="email" component="div" className="text-danger" />
                                                                </div>
                                                                <div className='form-group mb-3'>
                                                                    <div className='cs-label mb-2'>Phone Number</div>
                                                                    <Field
                                                                        type="text"
                                                                        name="phone"
                                                                        className="form-control" />
                                                                    <ErrorMessage name="phone" component="div" className="text-danger" />
                                                                </div>
                                                            </div>
                                                            <div className='col-md-6 wow reveal fadeInUp'>
                                                                <div className='form-group mb-3'>
                                                                    <div className='cs-label mb-2'>Comments</div>
                                                                    <Field
                                                                        type="text"
                                                                        name="comment"
                                                                        className="form-control h-218"
                                                                        component="textarea" />
                                                                    <ErrorMessage name="comment" component="div" className="text-danger" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='row mt-md-5 mt-3 justify-content-between about-action-flex wow reveal fadeInUp'>
                                                            <div className='col-md-6 fb-contact-info order-md-2 mb-md-0 mb-4'>
                                                                {vehicleData.location === "San Clemente, CA" ? 
                                                                    <a href='tel:9492731100' className='d-inline-flex align-items-center text-white phone-no-text mb-2'>
                                                                        <span className='fw-400 '><span className='call-icon'><img src={getImages('call.png')} alt='call' /></span></span>
                                                                        <span className='ps-md-3 ps-2'>(949) 273-1100</span>
                                                                    </a> : 
                                                                    <a href='tel:8135825202' className='d-inline-flex align-items-center text-white phone-no-text mb-2'>
                                                                        <span className='fw-400 '><span className='call-icon'><img src={getImages('call.png')} alt='call' /></span></span>
                                                                        <span className='ps-md-3 ps-2'>(813) 582-5202</span>
                                                                    </a>
                                                                }
                                                            </div>
                                                            <div className='col-md-6 text-md-end text-center order-md-2'>
                                                                <button className='black-red-btn text-uppercase w-240'>Send</button>
                                                            </div>
                                                        </div>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
                :
                <section className='vdp-wrap mnh-90vh'></section>
            }
        </>
    )
}

export default Vdp